import {Directive, Renderer, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
    selector: '[number-pad]'
})
export class NumberPadDirective {

    d1 = <any>$(this.el.nativeElement);
    @Input('number-pad') value;
    @Input('target-element') targetElement;

    constructor(private el: ElementRef,
                private renderer: Renderer) {
    }

    @HostListener('click', ['$event']) onClick($event) {
        console.info('clicked: ' + $event);
        $event.stopPropagation();
        console.info(this.targetElement);
        if (this.targetElement != '' && this.value != '') {
            var cPaidAmount = $('#' + this.targetElement).val();
            var tmpAmount_txt = $("#temp_number").html();
            if (parseFloat(this.value) >= 0 || (this.value).trim() == '.') {
                //var tmpAmount_output = (tmpAmount_txt).trim() + (this.value).trim();
                if ((this.value).trim() == '.') {
                    if(('' + cPaidAmount).includes('.')){
                        return 0;
                    }
                }
                if (this.targetElement != '') {
                    var updatedValue = ('' + cPaidAmount).trim() + ('' + this.value).trim();
                    $('#' + this.targetElement).val(updatedValue).change();
                    $('#' + this.targetElement).focus();
                }
            } else if ((this.value).trim() == 'C') {
                if (this.targetElement != '') {
                    $('#' + this.targetElement).val('').change();
                    $('#' + this.targetElement).focus();
                }
            }
        }
    }


}

export const NumberPad_DIRECTIVES = [
    NumberPadDirective
];



// WEBPACK FOOTER //
// /app/src/app/directives/number-pad/number-pad.directive.ts